<div class="flex h-screen bg-gray-100 font-sans text-sm">
  <!-- Left Sidebar (Inbox) -->
  <aside class="w-64 bg-white border-r flex flex-col p-4 space-y-4">
    <app-left-sidebar></app-left-sidebar>
  </aside>

  <!-- Main Content -->
  <main class="flex-1 flex flex-col bg-purple-50 overflow-y-auto">
    <header class="p-4 border-b bg-white space-y-3">
      <div>
        <h1 class="text-xl font-bold text-purple-800">Arhiva</h1>
        <p class="text-xs text-gray-500 mt-1">Pregled i pretraga arhiviranih brojeva</p>
      </div>

      <div class="flex flex-wrap items-end gap-3">
        <div class="flex flex-col gap-1 flex-1 min-w-[220px]">
          <label class="text-xs font-bold uppercase text-gray-500">Pretraga</label>
          <input
            type="text"
            [(ngModel)]="search"
            (ngModelChange)="loadNumbers()"
            class="border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
            placeholder="Pretraži ime ili broj..."
          />
        </div>

        <div class="flex flex-col gap-1 min-w-[180px]">
          <label class="text-xs font-bold uppercase text-gray-500">Provider</label>
          <select
            id="items"
            [(ngModel)]="selectedProviderCodeId"
            (change)="loadNumbers()"
            class="border rounded-lg p-2 bg-white focus:ring-2 focus:ring-purple-500 outline-none"
          >
            <option [ngValue]="null">Svi provideri</option>
            @for (providerCode of providerCodes; track providerCode.id) {
              <option [ngValue]="providerCode.id">{{ providerCode.prefix_code }} {{ providerCode.code }}</option>
            }
          </select>
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-xs font-bold uppercase text-gray-500">Od</label>
          <input
            type="date"
            [ngModel]="fromDate | date: 'yyyy-MM-dd'"
            (ngModelChange)="fromDate = $event; loadNumbers()"
            class="border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
          />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-xs font-bold uppercase text-gray-500">Do</label>
          <input
            type="date"
            [ngModel]="untilDate | date: 'yyyy-MM-dd'"
            (ngModelChange)="untilDate = $event; loadNumbers()"
            class="border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
          />
        </div>

        <button class="px-8 py-2 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition-colors">
          Sve
        </button>
      </div>
    </header>

    <div class="flex-1 p-6">
      <section class="bg-white border rounded-xl shadow-sm overflow-hidden">
        <div class="px-5 py-4 border-b flex items-center justify-between">
          <h2 class="font-bold text-purple-700">Brojevi</h2>
          <span class="text-xs font-semibold text-purple-700 bg-purple-100 rounded-full px-2 py-0.5">
            {{ numbers().length }}
          </span>
        </div>

        <table class="w-full">
          <thead class="bg-gray-50 border-b">
            <tr class="text-xs font-bold uppercase text-gray-500">
              <th class="text-left px-5 py-3">Provider</th>
              <th class="text-left px-5 py-3">Telefon</th>
              <th class="text-left px-5 py-3">Identitet</th>
              <th class="text-left px-5 py-3">Poslednja aktivnost</th>
              <th class="text-left px-5 py-3">Status</th>
            </tr>
          </thead>
          <tbody class="divide-y">
            @for (number of numbers(); track number.phone_number) {
              <tr class="hover:bg-purple-50/60 transition-colors">
                <td class="px-5 py-3">
                  <span class="text-xs font-mono font-bold text-purple-700 bg-purple-100 rounded px-2 py-0.5">
                    {{ number.prefix_code }}
                  </span>
                  <span class="text-gray-700 ml-1">{{ number.code }}</span>
                </td>
                <td class="px-5 py-3 font-mono text-gray-700">{{ number.phone_number }}</td>
                <td class="px-5 py-3 text-gray-700">{{ number.identity || '—' }}</td>
                <td class="px-5 py-3 text-gray-500">{{ number.newest_time | date: 'dd.MM.yyyy HH:mm' }}</td>
                <td class="px-5 py-3">
                  <div class="flex items-center gap-2">
                    @if (number.pinged_at) {
                      <span class="text-xs font-semibold rounded-full px-2 py-0.5 bg-green-100 text-green-700 whitespace-nowrap">
                        Isciman {{ number.pinged_at | date: 'dd.MM.yyyy HH:mm' }}
                      </span>
                    }
                    <button
                      type="button"
                      (click)="openChat(number)"
                      class="text-xs font-semibold rounded-full px-2 py-0.5 bg-amber-100 text-amber-700 hover:bg-amber-200 transition-colors whitespace-nowrap"
                    >
                      {{ number.pinged_at ? 'Cimni ponovo' : 'Cimni' }}
                    </button>
                  </div>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="5" class="px-5 py-8 text-center text-gray-400">Nema rezultata.</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    </div>
  </main>

  @if (selectedNumber(); as number) {
    <app-chat-modal
      [numberId]="number.number_id"
      [providerCodeId]="number.provider_code_id"
      [phoneNumber]="number.phone_number"
      (closeModal)="closeChat()"
      (pinged)="onPinged($event)"
    ></app-chat-modal>
  }
</div>
